module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-224.58dd4049.svg";